import { render, staticRenderFns } from "./BackToTopButton.vue?vue&type=template&id=1ed6e37b&scoped=true&"
import script from "./BackToTopButton.vue?vue&type=script&lang=ts&"
export * from "./BackToTopButton.vue?vue&type=script&lang=ts&"
import style0 from "./BackToTopButton.vue?vue&type=style&index=0&id=1ed6e37b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed6e37b",
  null
  
)

export default component.exports